import gql from 'graphql-tag';

export const planFragment = gql`
  fragment upsells_planFragment on PlanV2 {
    amount
    hasMeteredBilling
    hasMultiStepZaps
    hasPaths
    hasPremiumApps
    id
    interval
    name
    premiumAppsLimit
    tasks
    type
    zapLimit
  }
`;

export const accountFragment = gql`
  fragment upsells_accountFragment on Account {
    currency
    currentUserRole
    enabledTrialExtensions
    featureEnrollmentList {
      id
      featureName
      isEnrolled
    }
    id
    isTrialing
    isTrialingCompanies
    isTrialingTeams
    periodEndDate
    periodStartDate
    plan: planV2 {
      ...upsells_planFragment
    }
    taskBufferOverride
    usage {
      tasks {
        total
        limit
      }
    }
  }
  ${planFragment}
`;
